import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'acl-info-block',
  standalone: false,
  templateUrl: './info-block.component.html',
  styleUrl: './info-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoBlockComponent {
  data = input.required<any>();
}
